<template>
  <div
    class="exercise-list-item"
    :style="`--completion-icon-size: ${correctIcon ? '24px' : '40px'};`"
  >
    <jz-icon :src="exerciseTypeIcon" class="exercise-type-icon" />

    <span class="exercise-title">{{ exercise.title }}</span>

    <span class="tags">
      <span class="exercise-function">{{ skillTitle | __ }}</span>
      <span class="exercise-type">{{ `exercise.type.${exerciseType}` | __ }}</span>
    </span>

    <jz-icon v-if="completionIcon" :src="completionIcon" class="completion-icon" />
  </div>
</template>

<script>
import { getExerciseIcon, getSkillTitle } from "@tt-app/utils";

export default {
  name: "ExerciseListItem",
  props: {
    completionIcon: {
      type: String,
      default: ""
    },
    exercise: {
      type: Object,
      required: true
    }
  },
  computed: {
    exerciseType() {
      return this.exercise.exerciseType || this.exercise.type;
    },
    exerciseTypeIcon() {
      const type = this.exerciseType;
      if (type) {
        return getExerciseIcon(type, this.skill);
      }
      return "";
    },
    skill() {
      return this.exercise.skill;
    },
    skillTitle() {
      return getSkillTitle(this.exerciseType, this.skill);
    },
    correctIcon() {
      return this.completionIcon.includes("Correct");
    }
  }
};
</script>

<style lang="scss">
.exercise-list-item {
  column-gap: $gutter;
  display: grid;
  grid-template-areas: "type-icon title completion-icon" "type-icon tags completion-icon";
  grid-template-columns: 24px auto 40px;
  grid-template-rows: auto auto;
  padding: $gutter;
  row-gap: ($gutter / 4);

  & + .exercise-list-item {
    border-top: 1px solid rgba(var(--rgb-black), 0.08);
  }

  &:hover {
    cursor: pointer;
  }

  .exercise-type-icon {
    align-self: center;
    grid-area: type-icon;
    grid-column: 1;
    grid-row: 1 / 3;
  }

  .exercise-title {
    color: var(--color-dark);
    font-size: $font-size-sm;
    font-weight: bold;
    grid-area: title;
    grid-column: 2;
  }

  .tags {
    grid-area: tags;

    .exercise-function {
      background-color: var(--color-primary-alternate-background-light);
      border-radius: 4px;
      color: var(--color-secondary);
      font-size: $font-size-xxs;
      font-weight: bold;
      margin: 0 ($gutter / 4) 0 0;
      padding: ($gutter / 4);
    }

    .exercise-type {
      color: var(--color-secondary);
      font-size: $font-size-xs;
      font-weight: bold;
      grid-column: 2;
      grid-row: 2;
    }
  }

  .completion-icon {
    align-self: center;
    grid-area: completion-icon;
    grid-column: 3;
    grid-row: 1 / 3;
    height: var(--completion-icon-size);
    justify-self: center;
  }
}
</style>
